import React from 'react';
import { ReactRouterTextButton } from '@uds/react-router-adapter';
import { Size as TextButtonSize } from '@uds/text-button';
import { useIsExternalRoute } from 'domain/selectors/common';

import { RecursiveShortcodeProps } from './Shortcode';

const Link = ({ RecursiveShortcode, elements, contentType, attributes, against, ...rest }: RecursiveShortcodeProps) => {
  const [isExternalRoute, route] = useIsExternalRoute(attributes?.goto);
  return (
    <ReactRouterTextButton
      href={route}
      id={attributes?.analyticskey ? `shortcode-link-${attributes?.analyticskey}` : ''}
      contentType={contentType}
      size={TextButtonSize.INHERIT}
      isExternalRoute={isExternalRoute}
      rel={attributes?.rel}
      target={attributes?.newTab === 'true' ? '_blank' : ''}
    >
      {/* @ts-ignore: error when upgrading to @ux/config */}
      <RecursiveShortcode elements={elements} {...rest} />
    </ReactRouterTextButton>
  );
};

Link.displayName = 'Link';

export default Link;
